import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

// Generic Chart.js wrapper. Pass the chart type and Chart.js `data`/`options`
// objects as JSON via data attributes, e.g.:
//   data-controller="chart" data-chart-type-value="line"
//   data-chart-data-value="<%= chart_data.to_json %>"
export default class extends Controller {
  static values = {
    type: String,
    data: Object,
    options: Object
  }

  connect() {
    this.chart = new Chart(this.element, {
      type: this.typeValue,
      data: this.dataValue,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        ...this.optionsValue
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
